var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"donut",attrs:{"type":"donut","height":_vm.height,"options":_vm.donutChart.chartOptions,"series":_vm.donutChart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }